import { Injectable } from '@angular/core';
import { SupportedCollections, UploadFilePayload, UploadMediaPayloadKeys } from '@ag-common-lib/public-api';
import { CloudFunctionsService } from '../cloud-functions.service';
import { BaseElasticSearchService } from './base-elastic-search-service';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { LoadOptions } from 'devextreme/data';
import { fileToUIBase64 } from 'ag-common-svc/lib/components/ag-media-uploader/ag-media-uploader-modal.utils';
import { AgentTeamTransfer } from '@ag-common-lib/lib/models/functions/ship-document-to-elastic.model';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';

@Injectable()
export class AgentTeamTransferElasticSearchService extends BaseElasticSearchService<AgentTeamTransfer> {
  constructor(protected override cloudFunctionsService: CloudFunctionsService) {
    super(SupportedCollections.agentTeamTransfer, SupportedCollections.agentTeamTransfer);

    this.defaultSorting = [{ [BaseModelKeys.createdDate]: 'desc' }, '_doc'];
  }

  shipDocumentToElastic = (documentData: AgentTeamTransfer) => {
    return this.cloudFunctionsService.shipDocumentToElastic({
      indexName: SupportedCollections.agentTeamTransfer,
      documentData,
    });
  };

  getDataSource = (options?: LoadOptions) => {
    return new DataSource({
      paginate: true,
      pageSize: 50,

      store: this.getStore(options),
    });
  };

  getStore = (options?: LoadOptions) => {
    return new CustomStore({
      key: 'dbId',
      byKey: id => this.getById(id),
      load: loadOptions => {
        const params = { ...loadOptions, ...options };
        return this.getFromElastic(params);
      },
    });
  };

  async uploadHierarchyChangesFile(fileName, sourceFile: Blob) {
    const contentType = sourceFile.type;
    const base64 = await fileToUIBase64(sourceFile)
      .then(fileBase64 => {
        return fileBase64.split(',')[1];
      })
      .catch(() => {
        return null;
      });

    if (!base64) {
      return null;
    }

    const payload: UploadFilePayload = {
      [UploadMediaPayloadKeys.filePath]: SupportedCollections.agentTeamTransfer,
      [UploadMediaPayloadKeys.mediaData]: base64,
      [UploadMediaPayloadKeys.contentType]: contentType,
      [UploadMediaPayloadKeys.metadata]: {
        fileName,
      },
    };

    return this.cloudFunctionsService.uploadFile(payload).catch(() => {
      return null;
    });
  }
}
